<template>
  <div class="financial-statement-item">
    <col-table :data="financeData" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="endDate" label="报表截止日" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.endDate).isNull() }}
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>流动资产</template>
      </col-table-column>
      <col-table-column prop="cashAndShorttermInvestments" label="现金及现金等价物和短期投资">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.cashAndShorttermInvestments).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.cashAndShorttermInvestmentsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.cashAndShorttermInvestmentsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashAndCashEquivalents" label="- 现金和现金等价物">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.cashAndCashEquivalents).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.cashAndCashEquivalentsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.cashAndCashEquivalentsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="shorttermInvestments" label="- 短期投资">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.shorttermInvestments).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.shorttermInvestmentsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.shorttermInvestmentsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="prepaymentsReceivables" label="预付费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.prepaymentsReceivables).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.prepaymentsReceivablesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.prepaymentsReceivablesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="restrictedCash" label="受限制现金">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.restrictedCash).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.restrictedCashYoY).color() }" class="scale">
              {{ $digitjs(scope.row.restrictedCashYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="totalCurrentAssets"
        label="流动资产合计"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalCurrentAssets).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalCurrentAssetsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalCurrentAssetsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>非流动资产</template>
      </col-table-column>
      <col-table-column prop="propertyAndEquipmentNet" label="固定资产净额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.propertyAndEquipmentNet).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.propertyAndEquipmentNetYoY).color() }" class="scale">
              {{ $digitjs(scope.row.propertyAndEquipmentNetYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="intangibleAssetsAndGoodwill" label="商誉及其他无形资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.intangibleAssetsAndGoodwill).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.intangibleAssetsAndGoodwillYoY).color() }" class="scale">
              {{ $digitjs(scope.row.intangibleAssetsAndGoodwillYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="goodwill" label="- 商誉">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.goodwill).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.goodwillYoY).color() }" class="scale">
              {{ $digitjs(scope.row.goodwillYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="intangibleAssetsNet" label="- 其他无形资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.intangibleAssetsNet).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.intangibleAssetsNetYoY).color() }" class="scale">
              {{ $digitjs(scope.row.intangibleAssetsNetYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="longtermInvestments" label="投资和预付款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.longtermInvestments).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.longtermInvestmentsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.longtermInvestmentsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="longtermPrepaymentsReceivables" label="长期预付费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.longtermPrepaymentsReceivables).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.longtermPrepaymentsReceivablesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.longtermPrepaymentsReceivablesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="totalNonCurrentAssets"
        label="非流动资产合计"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalNonCurrentAssets).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalNonCurrentAssetsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalNonCurrentAssetsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalAssets" label="总资产" :css="{ ...mainDataStyle, marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalAssets).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalAssetsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalAssetsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>流动负债</template>
      </col-table-column>
      <col-table-column prop="accountsPayable" label="应付账款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.accountsPayable).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.accountsPayableYoY).color() }" class="scale">
              {{ $digitjs(scope.row.accountsPayableYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="incomeTaxPayable" label="- 应付税费">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.incomeTaxPayable).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.incomeTaxPayableYoY).color() }" class="scale">
              {{ $digitjs(scope.row.incomeTaxPayableYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="accruedExpensesAccountsPayable" label="应计费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.accruedExpensesAccountsPayable).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.accruedExpensesAccountsPayableYoY).color() }" class="scale">
              {{ $digitjs(scope.row.accruedExpensesAccountsPayableYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="currentBankBorrowings" label="短期借款与租赁负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.currentBankBorrowings).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.currentBankBorrowingsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.currentBankBorrowingsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="currentdeferredLiabilities" label="递延负债(流动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.currentdeferredLiabilities).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.currentdeferredLiabilitiesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.currentdeferredLiabilitiesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="merchantDeposits" label="- 客户存款及垫款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.merchantDeposits).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.merchantDepositsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.merchantDepositsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="currentdeferredRevenue" label="- 递延收入(流动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.currentdeferredRevenue).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.currentdeferredRevenueYoY).color() }" class="scale">
              {{ $digitjs(scope.row.currentdeferredRevenueYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="totalCurrentLiabilities"
        label="流动负债总额"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalCurrentLiabilities).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalCurrentLiabilitiesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalCurrentLiabilitiesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>非流动负债</template>
      </col-table-column>
      <col-table-column prop="nonCurrentBankBorrowings" label="长期借款与租赁负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.nonCurrentBankBorrowings).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.nonCurrentBankBorrowingsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.nonCurrentBankBorrowingsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonCurrentDeferredLiabilities" label="递延负债(非流动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.nonCurrentDeferredLiabilities).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.nonCurrentDeferredLiabilitiesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.nonCurrentDeferredLiabilitiesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonCurrentDeferredTaxLiabilities" label="- 递延所得税负债(非流动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.nonCurrentDeferredTaxLiabilities).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.nonCurrentDeferredTaxLiabilitiesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.nonCurrentDeferredTaxLiabilitiesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonCurrentDeferredRevenue" label="- 递延收入(非流动)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.nonCurrentDeferredRevenue).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.nonCurrentDeferredRevenueYoY).color() }" class="scale">
              {{ $digitjs(scope.row.nonCurrentDeferredRevenueYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherNonCurrentLiabilities" label="其他非流动负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherNonCurrentLiabilities).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherNonCurrentLiabilitiesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherNonCurrentLiabilitiesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="totalNonCurrentLiabilities"
        label="非流动负债总额"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalNonCurrentLiabilities).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalNonCurrentLiabilitiesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalNonCurrentLiabilitiesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalLiabilities" label="总负债" :css="{ ...mainDataStyle, marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalLiabilities).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalLiabilitiesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalLiabilitiesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>所有者权益</template>
      </col-table-column>
      <col-table-column prop="capital" label="股本">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.capital).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.capitalYoY).color() }" class="scale">
              {{ $digitjs(scope.row.capitalYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="ordinaryShares" label="- 普通股股本">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.ordinaryShares).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.ordinarySharesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.ordinarySharesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="preferredShares" label="- 优先股">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.preferredShares).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.preferredSharesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.preferredSharesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="retainedEarnings" label="留存收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.retainedEarnings).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.retainedEarningsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.retainedEarningsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="statutoryReserves" label="其他储备">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.statutoryReserves).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.statutoryReservesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.statutoryReservesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="additionalPaidinCapital" label="资本公积">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.additionalPaidinCapital).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.additionalPaidinCapitalYoY).color() }" class="scale">
              {{ $digitjs(scope.row.additionalPaidinCapitalYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="treasurySharesAtCost" label="库存股">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.treasurySharesAtCost).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.treasurySharesAtCostYoY).color() }" class="scale">
              {{ $digitjs(scope.row.treasurySharesAtCostYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherShareholdersEquity" label="归属于母公司股东权益其他项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherShareholdersEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherShareholdersEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherShareholdersEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalShareholdersEquity" label="归属于母公司股东权益" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalShareholdersEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalShareholdersEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalShareholdersEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonControllingInterests" label="少数股东权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.nonControllingInterests).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.nonControllingInterestsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.nonControllingInterestsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalLiabilitiesMezzanineEquityAndEquity" label="负债和股东权益合计">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalLiabilitiesMezzanineEquityAndEquity).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row.totalLiabilitiesMezzanineEquityAndEquityYoY).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row.totalLiabilitiesMezzanineEquityAndEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalEquity" label="总权益" :css="{ ...mainDataStyle, marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.totalEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.totalEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.totalEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="accountingStandard" label="会计准则">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.accountingStandard).isNull() }}
        </template>
      </col-table-column>
      <col-table-column prop="balanceSheetDate" label="年结日">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.balanceSheetDate).isNull() }}
        </template>
      </col-table-column>
      <col-table-column prop="reportDate" label="公布日期" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.reportDate).isNull() }}
        </template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['css', 'mainDataStyle'],
  data() {
    return {
      isSame: false,
      popupVisible: false,
      financeData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    pageSize() {
      return this.isSame ? 1 : 2
    }
  },
  created() {
    this.getIncomeStatement()
  },
  methods: {
    async getIncomeStatement() {
      const res = await this.$post(this.$api.f10.us + '/finance/balance-basic', {
        symbol: this.symbol,
        reportSize: 20,
        reportTypes: ['FY', 'Q4', 'Q9', 'Q3', 'Q6', 'Q2', 'Q1']
      })
      const reportTypeMap = {
        FY: 7,
        Q4: 6,
        Q9: 5,
        Q3: 4,
        Q6: 3,
        Q2: 2,
        Q1: 1
      }
      const data =
        res.data?.map((item) => {
          const { endDate, balanceSheetDate } = item
          const year = this.$dayjs(endDate).format('YYYY')
          const isBefore = this.$dayjs(year + '/' + balanceSheetDate).isBefore(this.$dayjs(endDate))
          item.sortYear = isBefore ? +year + 1 : +year
          return item
        }) ?? []
      this.financeData = data.sort(
        (a, b) => b.sortYear - a.sortYear || reportTypeMap[b.reportType] - reportTypeMap[a.reportType]
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
